import { inject, Injectable } from '@angular/core';
import { ApiCallingV2Service, ApiResponseModel, ResponseUtilityService, API_CONFIG } from '@zayan-erp/shared';
import { map, Observable } from 'rxjs';
import { DealUnderContract, Milestone } from '../models/deal-under-contract.model';

@Injectable({
  providedIn: 'root'
})
export class DealService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getDealsUnderContractByProspect(prospectId: string | null = null): Observable<DealUnderContract[]> {
    return this.#http
      .getData<
        DealUnderContract[] | DealUnderContract
      >(`${this.baseUrl}/deals/under-contract/prospect${prospectId ? `?prospectId=${prospectId}` : ''}`, { showLoader: true, showMessage: false })
      .pipe(map(data => (Array.isArray(data) ? data : data ? [data] : [])));
  }

  getMilestones(lotId: string): Observable<Milestone[]> {
    return this.#http.getData<Milestone[]>(`${this.baseUrl}/Lot/${lotId}/milestones`, {
      showLoader: true,
      showMessage: false
    });
  }
}
